import styled from "styled-components"
import { shade } from "polished"

interface SideBarProps {
  expanded: boolean
}

export const SidebarContainer = styled.div<SideBarProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: ${(props) => (props.expanded ? "200px" : "60px")};
  padding: 18px;

  @media (max-width: 768px) {
    width: ${(props) => (props.expanded ? "100vw" : "60px")};
    font-size: 20px;
  }

  background-color: ${(props) => props.theme.colors.primaryBlue};

  color: white;
  transition: width 0.4s ease;

  position: relative;

  div {
    cursor: pointer;
  }
`

export const SidebarHeader = styled.div<SideBarProps>`
  ${(props) => props.expanded && "align-self: flex-end;"}
  padding: 10px;
`

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (max-width: 768px) {
    gap: 20px;
  }

  a {
    color: white;
    text-decoration: none;
  }
`

export const MenuButton = styled.div<SideBarProps>`
  display: flex;
  align-items: center;
  width: 100%;

  padding: 15px;
  border-radius: 10px;
  margin-top: 5px;

  svg {
    margin-right: ${(props) => (props.expanded ? "20px" : "0px")};
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.secondaryBlue};
  }
`

export const SidebarFooter = styled.div`
  width: 100%;
  height: 60px;

  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  background-color: ${(props) => shade(0.1, props.theme.colors.primaryBlue)};

  display: flex;
  align-items: center;
  justify-content: center;

  a {
    color: white;
    text-decoration: none;

    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const Text = styled.text`
  margin-right: 30px;
`
